// Schools auto-rotation system

// Schools data by city
export const schoolsData = {
  Баксан: [
    {
      address: "пр-т Балкарский, 12",
      phone: "+7 (866) 345-67-01",
      email: "baksan1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
  Батайск: [
    {
      address: "ул. Центральная, 48",
      phone: "+7 (863) 205-11-10",
      email: "bataisk1@london-express.ru",
      hours: "9:00 - 20:00",
    },
    {
      address: "ул. Рабочая, 7",
      phone: "+7 (863) 205-11-11",
      email: "bataisk2@london-express.ru",
      hours: "10:00 - 21:00",
    },
  ],
  "Великий Новгород": [
    {
      address: "ул. Софийская, 22",
      phone: "+7 (816) 220-30-10",
      email: "vnovgorod1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
  Владикавказ: [
    {
      address: "пр-т Коста, 15",
      phone: "+7 (867) 240-55-10",
      email: "vladikavkaz1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "ул. Московская, 5",
      phone: "+7 (867) 240-55-11",
      email: "vladikavkaz2@london-express.ru",
      hours: "10:00 - 20:00",
    },
  ],
  Екатеринбург: [
    {
      address: "ул. Радищева, 32",
      phone: "+7 (343) 205-50-50",
      email: "ekb1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "ул. Луначарского, 81",
      phone: "+7 (343) 205-50-51",
      email: "ekb2@london-express.ru",
      hours: "10:00 - 20:00",
    },
  ],
  Ессентуки: [
    {
      address: "ул. Ленина, 10",
      phone: "+7 (879) 345-60-10",
      email: "essentuki1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
  Кисловодск: [
    {
      address: "пр-т Первомайский, 18",
      phone: "+7 (879) 372-20-20",
      email: "kislovodsk1@london-express.ru",
      hours: "9:00 - 21:00",
    },
  ],
  Когалым: [
    {
      address: "ул. Промышленная, 4",
      phone: "+7 (346) 675-40-10",
      email: "kogalym1@london-express.ru",
      hours: "9:00 - 19:00",
    },
  ],
  Красногорск: [
    {
      address: "б-р Строителей, 9",
      phone: "+7 (495) 505-77-10",
      email: "krasnogorsk1@london-express.ru",
      hours: "10:00 - 21:00",
    },
  ],
  Краснодар: [
    {
      address: "ул. Красная, 140",
      phone: "+7 (861) 210-30-10",
      email: "krasnodar1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "ул. Северная, 223",
      phone: "+7 (861) 210-30-11",
      email: "krasnodar2@london-express.ru",
      hours: "10:00 - 22:00",
    },
  ],
  Майкоп: [
    {
      address: "пр-т Дружбы Народов, 7",
      phone: "+7 (877) 225-15-10",
      email: "maykop1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
  Москва: [
    {
      address: "ул. Профсоюзная, 99",
      phone: "+7 (495) 123-46-01",
      email: "moscow1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "пр-т Мира, 120",
      phone: "+7 (495) 123-46-02",
      email: "moscow2@london-express.ru",
      hours: "10:00 - 20:00",
    },
  ],
  Нальчик: [
    {
      address: "пр-т Ленина, 35",
      phone: "+7 (866) 267-70-10",
      email: "nalchik1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
  Невинномысск: [
    {
      address: "ул. Гагарина, 25",
      phone: "+7 (865) 542-30-20",
      email: "nevinnomyssk1@london-express.ru",
      hours: "9:00 - 19:00",
    },
  ],
  Новороссийск: [
    {
      address: "ул. Советов, 55",
      phone: "+7 (861) 777-60-10",
      email: "novorossiysk1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "пр-т Ленина, 92",
      phone: "+7 (861) 777-60-11",
      email: "novorossiysk2@london-express.ru",
      hours: "10:00 - 20:00",
    },
  ],
  Одинцово: [
    {
      address: "Можайское ш., 45",
      phone: "+7 (495) 590-20-10",
      email: "odintsovo1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
  Пятигорск: [
    {
      address: "пр-т Калинина, 12",
      phone: "+7 (879) 320-40-10",
      email: "pyatigorsk1@london-express.ru",
      hours: "9:00 - 21:00",
    },
  ],
  "Славянск-на-Кубани": [
    {
      address: "ул. Красная, 28",
      phone: "+7 (861) 462-10-10",
      email: "slavyansk1@london-express.ru",
      hours: "9:00 - 19:00",
    },
  ],
  Сочи: [
    {
      address: "Курортный пр-т, 60",
      phone: "+7 (862) 240-50-10",
      email: "sochi1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "ул. Виноградная, 33",
      phone: "+7 (862) 240-50-11",
      email: "sochi2@london-express.ru",
      hours: "10:00 - 22:00",
    },
  ],
  Ставрополь: [
    {
      address: "пр-т Карла Маркса, 78",
      phone: "+7 (865) 255-40-10",
      email: "stavropol1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
  Сургут: [
    {
      address: "пр-т Ленина, 50",
      phone: "+7 (346) 223-40-10",
      email: "surgut1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "ул. Энтузиастов, 9",
      phone: "+7 (346) 223-40-11",
      email: "surgut2@london-express.ru",
      hours: "10:00 - 20:00",
    },
  ],
  Таганрог: [
    {
      address: "ул. Петровская, 65",
      phone: "+7 (863) 444-30-10",
      email: "taganrog1@london-express.ru",
      hours: "9:00 - 19:00",
    },
  ],
  Тюмень: [
    {
      address: "ул. Республики, 120",
      phone: "+7 (345) 270-80-10",
      email: "tyumen1@london-express.ru",
      hours: "9:00 - 21:00",
    },
  ],
  Челябинск: [
    {
      address: "пр-т Победы, 90",
      phone: "+7 (351) 678-90-20",
      email: "chelyabinsk1@london-express.ru",
      hours: "9:00 - 21:00",
    },
    {
      address: "ул. Братьев Кашириных, 130",
      phone: "+7 (351) 678-90-21",
      email: "chelyabinsk2@london-express.ru",
      hours: "10:00 - 20:00",
    },
  ],
  Черкесск: [
    {
      address: "ул. Октябрьская, 18",
      phone: "+7 (878) 222-30-10",
      email: "cherkessk1@london-express.ru",
      hours: "9:00 - 19:00",
    },
  ],
  Чита: [
    {
      address: "ул. Ленина, 95",
      phone: "+7 (302) 222-40-10",
      email: "chita1@london-express.ru",
      hours: "9:00 - 20:00",
    },
  ],
};

let currentCity = "Москва"
let currentSchoolIndex = 0
let autoRotateInterval = null
let isPaused = false
const ROTATE_INTERVAL = 5000 // 5 seconds

export function initSchoolsSystem() {
  // Initialize desktop schools
  updateSchoolsDropdown()
  updateContactsDisplay()
  startAutoRotation()

  // Pause rotation on hover
  const schoolsSection = document.querySelector(".header__schools")
  const contactsSection = document.querySelector(".header__contacts")

  if (schoolsSection) {
    schoolsSection.addEventListener("mouseenter", pauseRotation)
    schoolsSection.addEventListener("mouseleave", resumeRotation)
  }

  if (contactsSection) {
    contactsSection.addEventListener("mouseenter", pauseRotation)
    contactsSection.addEventListener("mouseleave", resumeRotation)
  }

  // Handle school selection from dropdown
  document.addEventListener("click", (e) => {
    const schoolItem = e.target.closest(".header__school-item")
    if (schoolItem) {
      const index = Number.parseInt(schoolItem.dataset.index, 10)
      if (!isNaN(index)) {
        currentSchoolIndex = index
        updateContactsDisplay()
        updateSchoolsDropdown()
      }
    }
  })
}

export function setCurrentCity(city) {
  if (schoolsData[city]) {
    currentCity = city
    currentSchoolIndex = 0
    updateSchoolsDropdown()
    updateContactsDisplay()
  }
}

function updateSchoolsDropdown() {
  const schools = schoolsData[currentCity] || []
  const schoolsList = document.querySelector(".header__schools-list")
  const addressSlider = document.querySelector(".header__schools-address-slider")

  if (schoolsList) {
    schoolsList.innerHTML = schools
      .map(
        (school, index) => `
      <div class="header__school-item ${index === currentSchoolIndex ? "header__school-item--active" : ""}" data-index="${index}">
        <div class="header__school-address">${school.address}</div>
        <div class="header__school-phone">
          <a href="tel:${school.phone.replace(/\s/g, "")}">${school.phone}</a>
        </div>
        <div class="header__school-hours">${school.hours}</div>
      </div>
    `,
      )
      .join("")
  }

  // Update address button text with animation
  if (addressSlider && schools[currentSchoolIndex]) {
    const currentItem = addressSlider.querySelector(".header__schools-address-item")
    if (currentItem) {
      currentItem.classList.remove("active")
      currentItem.classList.add("exit")

      setTimeout(() => {
        addressSlider.innerHTML = `
          <span class="header__schools-address-item active">${schools[currentSchoolIndex].address}</span>
        `
      }, 300)
    }
  }
}

function updateContactsDisplay() {
  const schools = schoolsData[currentCity] || []
  const school = schools[currentSchoolIndex]

  if (!school) return

  // Update phone with animation
  const phoneSlider = document.querySelector(".header__contacts .header__contacts-slider:first-child")
  if (phoneSlider) {
    const currentPhone = phoneSlider.querySelector(".header__phone")
    if (currentPhone) {
      currentPhone.classList.remove("header__phone--active")
      currentPhone.classList.add("header__phone--exit")

      setTimeout(() => {
        phoneSlider.innerHTML = `
          <a href="tel:${school.phone.replace(/\s/g, "")}" class="header__phone header__phone--active">${school.phone}</a>
        `
      }, 300)
    }
  }

  // Update email with animation
  const emailSlider = document.querySelector(".header__contacts .header__contacts-slider:last-child")
  if (emailSlider) {
    const currentEmail = emailSlider.querySelector(".header__email")
    if (currentEmail) {
      currentEmail.classList.remove("header__email--active")
      currentEmail.classList.add("header__email--exit")

      setTimeout(() => {
        emailSlider.innerHTML = `
          <a href="mailto:${school.email}" class="header__email header__email--active">${school.email}</a>
        `
      }, 300)
    }
  }

  // Update mini header phone
  const miniPhone = document.querySelector(".header__mini-phone")
  if (miniPhone) {
    miniPhone.textContent = school.phone
    miniPhone.href = `tel:${school.phone.replace(/\s/g, "")}`
  }

  // Update mobile menu contacts
  updateMobileContacts(school)
}

function updateMobileContacts(school) {
  const mobilePhone = document.querySelector(".header__mobile-phone-number")
  const mobilePhoneLink = document.querySelector(".header__mobile-phone-link")
  const mobileEmail = document.querySelector(".header__mobile-email-text")
  const mobileEmailLink = document.querySelector(".header__mobile-email-link")

  if (mobilePhone && mobilePhoneLink) {
    mobilePhone.textContent = school.phone
    mobilePhoneLink.href = `tel:${school.phone.replace(/\s/g, "")}`
  }

  if (mobileEmail && mobileEmailLink) {
    mobileEmail.textContent = school.email
    mobileEmailLink.href = `mailto:${school.email}`
  }
}

function startAutoRotation() {
  const schools = schoolsData[currentCity] || []

  // Only rotate if there are multiple schools
  if (schools.length <= 1) return

  autoRotateInterval = setInterval(() => {
    if (!isPaused) {
      currentSchoolIndex = (currentSchoolIndex + 1) % schools.length
      updateContactsDisplay()
      updateSchoolsDropdown()
    }
  }, ROTATE_INTERVAL)
}

function stopAutoRotation() {
  if (autoRotateInterval) {
    clearInterval(autoRotateInterval)
    autoRotateInterval = null
  }
}

function pauseRotation() {
  isPaused = true
}

function resumeRotation() {
  isPaused = false
}

// Update rotation when city changes
export function onCityChange(newCity) {
  stopAutoRotation()
  setCurrentCity(newCity)
  startAutoRotation()
}
